<template>
  <generic-modal :title="$t('style')" :buttons="buttons" ref="generic_modal">
    <div>
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.name" />
        </div>
      </div>
      <!-- <div class="field" v-if="meta.settings">
        <label class="label">{{ $t("image url") }}</label>
        <div class="control">
          <input class="input" type="text" v-model="meta.settings.image_url" />
        </div>
      </div> -->
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "StyleModal",
  components: { GenericModal },
  data() {
    return {
      api_host,
      buttons: [
        {
          text: this.$t("save"),
          class: "is-primary is-rounded",
          icon: "fa fa-save",
          click: this.save,
          disabled: "this.is_form_invalid",
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(uuid) {
      let v = this;
      v.set_initial_state();

      if (uuid) {
        // v.uuid = product_uuid;
        get("/museum/style", { uuid: uuid })
          .then((category) => {
            v.meta = category;
            v.$refs.generic_modal.show_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        v.$refs.generic_modal.show_modal();
      }
    },
    save() {
      let v = this;
      if (!v.meta.uuid)
        put("/museum/style", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      else
        post("/museum/style", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
